var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirtel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 78,
    viewBox: "0 0 160 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_1120)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1800_1120",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 0.263191H159.315V77.1958H0.6875V0.263191Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1800_1120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.212 56.2951C143.383 56.2951 142.711 55.5878 142.711 54.7152V36.9685L138.697 37.5873V54.5844C138.697 57.055 140.615 59.0586 142.98 59.0586H145.211V56.2951H144.212Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7695 59.0586H101.783V42.1664L97.7695 42.7851V59.0586Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.328 45.132V46.3167V59.0601H108.343V48.0147L108.32 46.7107C108.32 44.6495 112.948 45.0446 112.948 45.0446L114.395 41.886C107.991 40.0654 104.328 45.132 104.328 45.132Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.676 54.7152V44.9338H122.089V41.8636H119.676V36.9685L115.662 37.5873V54.5844C115.662 57.055 117.58 59.0586 119.945 59.0586H122.177V56.2951H121.178C120.349 56.2951 119.676 55.5878 119.676 54.7152Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7715 35.4865C98.3993 35.4865 97.2871 36.5987 97.2871 37.9708C97.2871 39.3419 98.3993 40.4541 99.7715 40.4541C101.143 40.4541 102.255 39.3419 102.255 37.9708C102.255 36.5987 101.143 35.4865 99.7715 35.4865Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.341 44.682C132.643 44.682 133.104 47.9362 133.104 47.9362H132.972H127.577C127.577 47.9362 128.038 44.682 130.341 44.682ZM129.781 55.9345C127.116 54.9135 127.314 50.9333 127.314 50.9333H136.953C136.953 45.9365 135.751 41.6178 130.9 41.6178C126.048 41.6178 123.168 45.1798 123.168 50.1761C123.168 55.1734 126.246 59.0596 131.097 59.0596C133.024 59.0596 135.661 58.4199 137.109 57.3368L135.735 54.947C135.735 54.947 132.445 56.9538 129.781 55.9345Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5387 55.7036C91.5387 55.7036 88.9071 56.9323 87.2184 55.9223C85.5292 54.9134 85.727 52.151 87.3168 51.2948C88.9071 50.4398 91.5387 50.9662 91.5387 50.9662V55.7036ZM89.8242 41.7398C89.8242 41.7398 88.1273 41.7645 86.4178 42.0931C84.8115 42.4008 83.2009 43.5065 83.2009 43.5065L84.4763 46.1299C84.4763 46.1299 86.1221 44.5841 88.6878 44.5841C92.1097 44.5841 91.6266 48.0147 91.6266 48.0147C84.961 46.6486 81.6864 50.0705 81.7793 53.5967C81.8205 55.1991 82.0397 56.823 83.8625 58.0281C89.6967 61.889 95.3606 56.2734 95.3606 56.2734V46.9586C95.3606 44.167 92.8817 41.7398 89.8242 41.7398Z",
    fill: "#EE3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8657 23.9056C8.7052 40.3549 15.2555 45.8275 19.5978 47.9371C23.9406 50.0462 29.7309 47.1502 36.9691 41.4918C44.2068 35.8329 60.9633 24.9112 64.9111 30.3498C68.8594 35.7895 68.9467 46.5804 52.0144 60.7926C35.0826 75.0053 31.5734 66.6927 39.9299 60.1788C48.2859 53.6642 46.7511 49.7384 42.8028 49.1686C38.66 48.5702 35.0826 49.5632 31.3981 56.3217C31.3981 56.3217 25.7579 67.2109 32.9774 70.0047C38.0033 71.9505 52.8469 65.9608 63.7488 54.9809C71.78 46.8919 77.6577 37.2193 75.1981 24.3183C71.974 7.40848 45.0262 7.45519 26.8657 23.9056Z",
    fill: "#EE3338"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_1120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.628,
    height: 76.9326,
    fill: "white",
    transform: "translate(0.685547 0.263184)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtel);
export default __webpack_public_path__ + "static/media/airtel.43d8826c8506a1f88fb21b6ca01d24d5.svg";
export { ForwardRef as ReactComponent };